{
  "dashboard": "Government Dashboard",
  "applications": "Applications",
  "oversight": "Registry Oversight",
  "dashboard_page": {
    "title": "Dashboard Overview",
    "subtitle": "Government DNA Access Management",
    "admin_user": "Admin User",
    "stats": {
      "registered_projects": "Registered Projects",
      "pending_approvals": "Pending Approvals",
      "credits_issued": "Credits Issued",
      "active_transfers": "Active Transfers",
      "pending_applications": "Pending Applications",
      "certificates_issued": "Certificates Issued",
      "active_projects": "Active Projects",
      "open_grievances": "Open Grievances"
    },
    "quick_actions": {
      "application_queue": {
        "title": "Application Queue",
        "pin": "Project Information Note",
        "pdd": "Project Design Document",
        "authorization": "Authorization Request",
        "pending": "Pending",
        "review": "Review",
        "approved": "Approved"
      },
      "recent_certificates": {
        "title": "Recent Certificates",
        "credit_registration": "Credit Registration",
        "letter_authorization": "Letter of Authorization",
        "credit_cancellation": "Credit Cancellation",
        "issued": "Issued",
        "processing": "Processing"
      }
    },
    "registry_overview": {
      "title": "Registry Oversight",
      "verified_emissions": "Verified Emissions",
      "retired_credits": "Retired Credits",
      "pending_transfer": "Pending Transfer",
      "tco2e": "tCO2e",
      "credits": "Credits"
    },
    "ndc_allocation": {
      "title": "NDC Allocation",
      "total_allocation": "Total Allocation",
      "renewable_energy": "Renewable Energy",
      "forestry": "Forestry",
      "agriculture": "Agriculture"
    },
    "buffer_account": {
      "title": "Buffer Account",
      "national_buffer": "National Buffer",
      "transaction_account": "Transaction Account",
      "available_credits": "Available Credits"
    },
    "pending_approvals": {
      "title": "Pending Project Approvals",
      "view_all": "View All Applications",
      "project_id": "Project ID",
      "project_name": "Project Name",
      "developer": "Developer",
      "submitted": "Submitted",
      "type": "Type",
      "status": "Status",
      "actions": "Actions",
      "review": "Review",
      "approve": "Approve",
      "reject": "Reject",
      "under_review": "Under Review",
      "documentation_required": "Documentation Required",
      "technical_review": "Technical Review"
    },
    "international_transfers": {
      "title": "International Transfers",
      "view_all_transfers": "View All Transfers",
      "transfer_id": "Transfer ID",
      "from_country": "From Country",
      "to_country": "To Country",
      "credits": "Credits",
      "date": "Date",
      "status": "Status",
      "authorize": "Authorize",
      "authorized": "Authorized",
      "pending_authorization": "Pending Authorization"
    },
    "registry_insights": {
      "title": "Registry Insights",
      "total_projects": "Total Projects",
      "this_month": "this month",
      "compliance_rate": "Compliance Rate",
      "avg_processing_time": "Avg Processing Time",
      "days": "days"
    }
  },
  "register_page": {
    "title": "Government / DNA Registration",
    "subtitle": "Administrative oversight and regulatory management access for Designated National Authorities",
    "dna_requirements": {
      "title": "DNA Authority Requirements",
      "official_designation": "Official government designation as DNA",
      "unfccc_coordination": "UNFCCC national registry coordination",
      "legal_authority": "Legal authority for carbon market oversight",
      "article6_mandate": "Article 6 implementation mandate"
    },
    "admin_functions": {
      "title": "Administrative Functions",
      "project_approval": "Project approval and authorization",
      "registry_oversight": "Registry oversight and monitoring",
      "transfer_authorization": "International transfer authorization",
      "compliance_enforcement": "Compliance and enforcement tools"
    },
    "access_levels": {
      "title": "Access Levels",
      "observer": {
        "title": "Observer",
        "description": "Read-only registry access"
      },
      "administrator": {
        "title": "Administrator",
        "description": "Full regulatory oversight"
      }
    },
    "application_process": {
      "title": "Application Process",
      "step1": "Submit official DNA designation letter",
      "step2": "Provide UNFCCC authorization documentation",
      "step3": "Complete technical integration requirements",
      "step4": "Undergo security clearance verification"
    },
    "contact_info": {
      "title": "For DNA registration inquiries, please contact:",
      "email": "Email",
      "phone": "Phone",
      "office_hours": "Office Hours: Monday - Friday, 9:00 AM - 5:00 PM UTC"
    },
    "actions": {
      "request_access": "Request DNA Portal Access",
      "download_requirements": "Download Requirements Document"
    },
    "registration_status": "Government access registration is currently in development. Please check back soon.",
    "buttons": {
      "register_new_dna": "Register New DNA",
      "access_existing_portal": "Access Existing Portal"
    }
  },
  "sidebar": {
    "portal_title": "DNA Access Portal",
    "portal_subtitle": "Government Dashboard",
    "dashboard": "Dashboard",
    "application_queue": "Application Queue",
    "certificates": "Certificates",
    "registry_oversight": "Registry Oversight",
    "grievance_management": "Grievance Management",
    "doe_licenses": "DOE Licenses",
    "unfccc_reporting": "UNFCCC Reporting",
    "administration": "Administration",
    "settings": "Settings",
    "logout": "Logout"
  },
  "application_queue": {
    "title": "Application Queue",
    "subtitle": "Pending Applications - PIN, PDD & Authorizations",
    "filters": {
      "application_type": "Application Type:",
      "all_types": "All Types",
      "pin": "PIN",
      "pdd": "PDD",
      "authorization": "Authorization",
      "status": "Status:",
      "all_status": "All Status",
      "pending_review": "Pending Review",
      "under_review": "Under Review",
      "approved": "Approved",
      "rejected": "Rejected",
      "date_range": "Date Range:",
      "to": "to",
      "filter": "Filter"
    },
    "stats": {
      "total_applications": "Total Applications",
      "pin_applications": "PIN Applications",
      "pdd_applications": "PDD Applications",
      "authorizations": "Authorizations"
    },
    "table": {
      "title": "Pending Applications",
      "export": "Export",
      "new_review": "New Review",
      "columns": {
        "application_id": "Application ID",
        "type": "Type",
        "project_name": "Project Name",
        "applicant": "Applicant",
        "submitted": "Submitted",
        "status": "Status",
        "priority": "Priority",
        "actions": "Actions"
      },
      "priority": {
        "high": "High",
        "medium": "Medium",
        "low": "Low"
      },
      "actions": {
        "review": "Review",
        "details": "Details",
        "reopen": "Reopen"
      }
    },
    "pagination": {
      "showing": "Showing",
      "to": "to",
      "of": "of",
      "results": "results",
      "previous": "Previous",
      "next": "Next"
    }
  },
  "certificates": {
    "title": "Certificates & Letters Issuance",
    "subtitle": "Issue CR, LOA, and CCI documents",
    "action_buttons": {
      "issue_cr": "Issue Credit Registration (CR)",
      "issue_loa": "Issue Letter of Authorization (LOA)",
      "issue_cci": "Issue Credit Cancellation (CCI)"
    },
    "filters": {
      "search_placeholder": "Search by ID, Project Name, or Organization",
      "all_certificate_types": "All Certificate Types",
      "credit_registration": "Credit Registration (CR)",
      "letter_authorization": "Letter of Authorization (LOA)",
      "credit_cancellation": "Credit Cancellation (CCI)",
      "all_status": "All Status",
      "draft": "Draft",
      "pending_approval": "Pending Approval",
      "issued": "Issued",
      "cancelled": "Cancelled",
      "filter": "Filter"
    },
    "stats": {
      "total_issued": "Total Issued",
      "cr_documents": "CR Documents",
      "loa_documents": "LOA Documents",
      "cci_documents": "CCI Documents"
    },
    "table": {
      "title": "Recent Certificates & Letters",
      "columns": {
        "document_id": "Document ID",
        "type": "Type",
        "project_name": "Project Name",
        "organization": "Organization",
        "issue_date": "Issue Date",
        "status": "Status",
        "actions": "Actions"
      },
      "document_types": {
        "cr": "CR",
        "loa": "LOA",
        "cci": "CCI"
      }
    },
    "pagination": {
      "showing": "Showing",
      "of": "of",
      "certificates": "certificates",
      "previous": "Previous",
      "next": "Next"
    }
  },
  "registry_oversight": {
    "title": "Registry Oversight",
    "subtitle": "Project monitoring and credit management",
    "filters": {
      "all_project_types": "All Project Types",
      "renewable_energy": "Renewable Energy",
      "forestry": "Forestry",
      "agriculture": "Agriculture",
      "energy_efficiency": "Energy Efficiency",
      "all_developers": "All Developers",
      "all_status": "All Status",
      "active": "Active",
      "pending": "Pending",
      "suspended": "Suspended",
      "all_standards": "All Standards",
      "vcs": "VCS",
      "gold_standard": "Gold Standard",
      "cdm": "CDM",
      "apply_filters": "Apply Filters",
      "export": "Export"
    },
    "project_tags": {
      "title": "Project Tags",
      "article6_eligible": "Article 6.2 Eligible",
      "in_buffer": "In Buffer",
      "pending_transfer": "Pending Transfer"
    },
    "account_ledger": {
      "verified_emissions": {
        "title": "Verified Emissions",
        "total_verified": "Total Verified",
        "this_month": "This Month"
      },
      "retired_credits": {
        "title": "Retired Credits",
        "total_retired": "Total Retired"
      },
      "pending_transfer": {
        "title": "Pending Transfer",
        "awaiting_transfer": "Awaiting Transfer",
        "processing": "Processing"
      }
    },
    "projects_table": {
      "title": "Project Registry",
      "columns": {
        "project_id": "Project ID",
        "type": "Type",
        "developer": "Developer",
        "status": "Status",
        "credits": "Credits",
        "tags": "Tags",
        "actions": "Actions"
      }
    },
    "ownership_history": {
      "title": "Ownership History",
      "credit_transfer": "Credit Transfer",
      "credit_issuance": "Credit Issuance"
    },
    "pagination": {
      "showing": "Showing",
      "of": "of",
      "projects": "projects",
      "previous": "Previous",
      "next": "Next"
    }
  },
  "grievance_management": {
    "title": "Grievance Management",
    "subtitle": "Track and manage project grievances and complaints",
    "new_grievance": "New Grievance",
    "stats": {
      "open_grievances": "Open Grievances",
      "under_investigation": "Under Investigation",
      "resolved_this_month": "Resolved This Month",
      "avg_resolution_time": "Avg Resolution Time",
      "days": "days"
    },
    "filters": {
      "search_placeholder": "Search grievances...",
      "all_status": "All Status",
      "open": "Open",
      "under_investigation": "Under Investigation",
      "resolved": "Resolved",
      "closed": "Closed",
      "all_priority": "All Priority",
      "high": "High",
      "medium": "Medium",
      "low": "Low",
      "all_projects": "All Projects",
      "filter": "Filter"
    },
    "grievance_list": {
      "title": "Active Grievances",
      "columns": {
        "grievance_id": "Grievance ID",
        "project": "Project",
        "complainant": "Complainant",
        "category": "Category",
        "priority": "Priority",
        "status": "Status",
        "date_submitted": "Date Submitted",
        "actions": "Actions"
      },
      "categories": {
        "environmental": "Environmental",
        "social_impact": "Social Impact",
        "economic": "Economic",
        "procedural": "Procedural"
      },
      "roles": {
        "community_rep": "Community Rep",
        "local_farmer": "Local Farmer",
        "traditional_leader": "Traditional Leader",
        "ngo_representative": "NGO Representative"
      }
    },
    "pagination": {
      "showing": "Showing",
      "of": "of",
      "grievances": "grievances",
      "previous": "Previous",
      "next": "Next"
    }
  },
  "doe_licenses": {
    "title": "DOE Licenses",
    "subtitle": "Designated Operational Entity License Management",
    "new_license": "New License",
    "admin_user": "Admin User",
    "search_filters": {
      "search_label": "Search",
      "search_placeholder": "Search by organization name...",
      "status_label": "Status",
      "all_status": "All Status",
      "active": "Active",
      "pending": "Pending",
      "suspended": "Suspended",
      "expired": "Expired",
      "license_type_label": "License Type",
      "all_types": "All Types",
      "validation": "Validation",
      "verification": "Verification",
      "both": "Both",
      "actions_label": "Actions",
      "filter": "Filter",
      "export": "Export"
    },
    "stats": {
      "total_licenses": "Total Licenses",
      "active_licenses": "Active Licenses",
      "pending_review": "Pending Review",
      "expiring_soon": "Expiring Soon"
    },
    "table": {
      "title": "DOE License Registry",
      "columns": {
        "organization": "Organization",
        "license_id": "License ID",
        "type": "Type",
        "contact": "Contact",
        "status": "Status",
        "expiry_date": "Expiry Date",
        "actions": "Actions"
      },
      "status_labels": {
        "active": "Active",
        "pending": "Pending",
        "expiring": "Expiring"
      },
      "type_labels": {
        "validation": "Validation",
        "verification": "Verification",
        "both": "Both"
      }
    },
    "pagination": {
      "showing": "Showing",
      "to": "to",
      "of": "of",
      "results": "results",
      "previous": "Previous",
      "next": "Next"
    }
  },
  "unfccc_reporting": {
    "title": "UNFCCC Reporting Exports",
    "subtitle": "Generate and export UNFCCC reports and adjustment summaries",
    "admin_user": "Admin User",
    "report_generation": {
      "title": "Generate UNFCCC Reports",
      "export_all_reports": "Export All Reports",
      "report_parameters": "Report Parameters",
      "reporting_period_label": "Reporting Period",
      "report_type_label": "Report Type",
      "report_types": {
        "full_report": "Full Report",
        "summary_report": "Summary Report",
        "adjustment_report": "Adjustment Report"
      },
      "project_categories_label": "Project Categories",
      "categories": {
        "all_categories": "All Categories",
        "renewable_energy": "Renewable Energy",
        "forestry_land_use": "Forestry & Land Use",
        "agriculture": "Agriculture"
      },
      "article6_status_label": "Article 6.2 Status",
      "article6_options": {
        "article6_eligible": "Article 6.2 Eligible",
        "in_buffer": "In Buffer",
        "pending_transfer": "Pending Transfer"
      }
    },
    "report_preview": {
      "title": "Report Preview",
      "estimated_report_size": "Estimated Report Size",
      "total_projects": "Total Projects",
      "total_credits": "Total Credits",
      "last_updated": "Last Updated",
      "generate_pdf_report": "Generate PDF Report",
      "generate_excel_report": "Generate Excel Report",
      "generate_csv_report": "Generate CSV Report"
    },
    "corresponding_adjustments": {
      "title": "Corresponding Adjustments Summary",
      "refresh_data": "Refresh Data",
      "stats": {
        "total_adjustments": "Total Adjustments",
        "positive_adjustments": "Positive Adjustments",
        "negative_adjustments": "Negative Adjustments",
        "pending_adjustments": "Pending Adjustments",
        "tco2e": "tCO2e"
      },
      "table": {
        "columns": {
          "project_id": "Project ID",
          "project_name": "Project Name",
          "sector": "Sector",
          "adjustment_type": "Adjustment Type",
          "amount_tco2e": "Amount (tCO2e)",
          "status": "Status",
          "date": "Date"
        },
        "adjustment_types": {
          "positive": "Positive",
          "negative": "Negative"
        },
        "status_labels": {
          "processed": "Processed",
          "pending": "Pending"
        }
      }
    },
    "export_history": {
      "title": "Export History",
      "filter": "Filter",
      "status": {
        "completed": "Completed"
      },
      "download": "Download"
    }
  },
  "administration": {
    "title": "Administration",
    "subtitle": "User Management & System Configuration",
    "admin_user": "Admin User",
    "tabs": {
      "user_management": "User Management",
      "sector_management": "Sector Management",
      "ndc_allocation": "NDC Allocation",
      "buffer_accounts": "Buffer Accounts",
      "transaction_accounts": "Transaction Accounts"
    },
    "userManagement": {
      "title": "User Management",
      "form": {
        "title": "Add New User",
        "labels": {
          "organizationName": "Organization Name",
          "address": "Address",
          "contactNumber": "Contact Number",
          "pointOfContactName": "Point of Contact Name",
          "role": "Role",
          "contactEmail": "Contact Email",
          "phoneNumber": "Phone Number",
          "username": "Username",
          "password": "Password"
        },
        "placeholders": {
          "organizationName": "Enter organization name",
          "address": "Enter address",
          "contactNumber": "Enter contact number",
          "pointOfContactName": "Enter contact name",
          "contactEmail": "Enter email address",
          "phoneNumber": "Enter phone number",
          "username": "Enter username",
          "password": "Enter password"
        },
        "buttons": {
          "addUser": "Add User"
        }
      },
      "userList": {
        "title": "Manage Users",
        "search": {
          "placeholder": "Search users...",
          "allRoles": "All Roles"
        },
        "table": {
          "headers": {
            "organization": "Organization",
            "contactPerson": "Contact Person",
            "role": "Role",
            "email": "Email",
            "status": "Status",
            "actions": "Actions"
          }
        },
        "pagination": {
          "showing": "Showing",
          "to": "to",
          "of": "of",
          "results": "results",
          "previous": "Previous",
          "next": "Next"
        }
      },
      "roles": {
        "selectRole": "Select Role",
        "admin": "Admin",
        "reviewer": "Reviewer",
        "operator": "Operator",
        "viewer": "Viewer"
      },
      "status": {
        "active": "Active",
        "inactive": "Inactive"
      }
    },
    "sectorManagement": {
      "title": "Methodology Management",
      "controls": {
        "title": "Methodology Management",
        "buttons": {
          "addMethodology": "Add Methodology",
          "export": "Export"
        },
        "filters": {
          "sectorLabel": "Filter by Sector",
          "allSectors": "All Sectors",
          "renewableEnergy": "Renewable Energy",
          "forestry": "Forestry",
          "agriculture": "Agriculture",
          "wasteManagement": "Waste Management",
          "transportation": "Transportation",
          "industrial": "Industrial",
          "waste": "Waste",
          "statusLabel": "Approval Status",
          "allStatus": "All Status",
          "approved": "Approved",
          "notApproved": "Not Approved",
          "underReview": "Under Review",
          "searchLabel": "Search",
          "searchPlaceholder": "Search methodologies..."
        }
      },
      "approvedMethodologies": {
        "title": "Approved Methodologies for Jurisdiction",
        "count": "Methodologies",
        "table": {
          "headers": {
            "methodologyId": "Methodology ID",
            "sector": "Sector",
            "title": "Title",
            "version": "Version",
            "approvalDate": "Approval Date",
            "actions": "Actions"
          }
        }
      },
      "nonApprovedMethodologies": {
        "title": "Methodologies NOT Approved for Jurisdiction",
        "count": "Methodologies",
        "table": {
          "headers": {
            "methodologyId": "Methodology ID",
            "sector": "Sector",
            "title": "Title",
            "reason": "Reason",
            "reviewDate": "Review Date",
            "actions": "Actions"
          }
        },
        "rejectionReasons": {
          "incompatiblePolicy": "Incompatible with national policy",
          "technicalRequirements": "Technical requirements not met"
        }
      },
      "sectorsNotApproved": {
        "title": "Sectors NOT Approved",
        "addButton": "Add Restricted Sector",
        "restrictions": {
          "permanentlyRestricted": "Permanently Restricted",
          "policyRestricted": "Policy Restricted",
          "underReview": "Under Review"
        },
        "sectors": {
          "coalMining": "Coal Mining",
          "oilGasExtraction": "Oil & Gas Extraction",
          "nuclearEnergy": "Nuclear Energy"
        },
        "descriptions": {
          "coalMining": "Coal extraction and related activities",
          "oilGasExtraction": "Petroleum and natural gas extraction",
          "nuclearEnergy": "Nuclear power generation activities"
        }
      }
    },
    "ndcAllocation": {
        "buttons": {
          "saveChanges": "Save Changes",
          "reset": "Reset"
        },
        "lastUpdated": "Last updated:",
        "allocation": {
          "title": "NDC Allocation Percentages",
          "total": "Total:",
          "applyToAll": "Apply to All Sectors"
        },
        "sectors": {
          "renewableEnergy": "Renewable Energy",
          "forestryLandUse": "Forestry & Land Use",
          "agriculture": "Agriculture",
          "transportation": "Transportation",
          "industrialProcesses": "Industrial Processes",
          "wasteManagement": "Waste Management"
        },
        "bufferAccount": {
          "title": "National Buffer Account",
          "total": "Total:",
          "applyToAll": "Apply to All Sectors"
        },
        "transactionAccount": {
          "title": "National Transaction Account",
          "total": "Total:",
          "applyToAll": "Apply to All Sectors"
        },
        "placeholders": {
          "percentage": "%"
        }
      },
      "bufferAccounts": {
        "overview": {
          "totalBufferAllocation": "Total Buffer Allocation",
          "activeSectors": "Active Sectors",
          "bufferCredits": "Buffer Credits"
        },
        "configuration": {
          "title": "Buffer Account Configuration",
          "saveChanges": "Save Changes"
        },
        "globalSettings": {
          "title": "Global Buffer Settings",
          "applyToAllSectors": "Apply to all sectors",
          "globalPercentage": "Global Percentage:"
        },
        "sectorSettings": {
          "title": "Sector-Specific Buffer Allocation",
          "enableSectorSpecific": "Enable sector-specific allocation"
        },
        "sectors": {
          "renewableEnergy": {
            "title": "Renewable Energy",
            "description": "Solar, Wind, Hydro projects"
          },
          "forestryLandUse": {
            "title": "Forestry & Land Use", 
            "description": "REDD+, Afforestation projects"
          },
          "agriculture": {
            "title": "Agriculture",
            "description": "Sustainable farming, livestock"
          },
          "wasteManagement": {
            "title": "Waste Management",
            "description": "Landfill gas, composting"
          },
          "manufacturing": {
            "title": "Manufacturing",
            "description": "Industrial efficiency, fuel switching"
          },
          "transport": {
            "title": "Transport", 
            "description": "Modal shift, efficiency improvements"
          }
        },
        "summary": {
          "activeAllocations": {
            "title": "Active Buffer Allocations",
            "forestryCredits": "credits in buffer",
            "agricultureCredits": "credits in buffer",
            "transportCredits": "credits in buffer"
          },
          "activity": {
            "title": "Buffer Account Activity",
            "creditsAdded": "Credits Added",
            "creditsReleased": "Credits Released",
            "netChange": "Net Change",
            "last30Days": "Last 30 days"
          }
        }
      },
      "transactionAccounts": {
        "summary": {
          "totalAllocation": "Total Allocation",
          "activeSectors": "Active Sectors", 
          "remaining": "Remaining"
        },
        "globalSettings": {
          "title": "Global Allocation Settings",
          "applyToAllSectors": "Apply to All Sectors",
          "percentage": "Percentage:",
          "sectorSpecificAllocation": "Sector-Specific Allocation",
          "buttons": {
            "reset": "Reset",
            "applyGlobal": "Apply Global"
          }
        },
        "sectorAllocation": {
          "title": "Sector-wise Allocation",
          "buttons": {
            "addSector": "Add Sector",
            "saveChanges": "Save Changes"
          },
          "table": {
            "headers": {
              "sectorName": "Sector Name",
              "currentAllocation": "Current Allocation",
              "newAllocation": "New Allocation (%)",
              "status": "Status",
              "actions": "Actions"
            }
          },
          "sectors": {
            "renewableEnergy": "Renewable Energy",
            "forestryLandUse": "Forestry & Land Use",
            "agriculture": "Agriculture", 
            "wasteManagement": "Waste Management",
            "transportation": "Transportation"
          },
          "status": {
            "active": "Active",
            "pending": "Pending",
            "inactive": "Inactive"
          }
        },
        "footer": {
          "totalAllocated": "Total Allocated:",
          "remaining": "Remaining:",
          "buttons": {
            "cancel": "Cancel",
            "saveAllChanges": "Save All Changes"
          }
        }
      }
    }
  }